import FlightListApp from "flights/list/app";
import { FlightDetailApp } from "flights/detail/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const flightRoute: RouteObject = {
  path: "flight",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: FlightListApp,
  }, {
    path: "detail/:key",
    loader: () => viewModel,
    Component: FlightDetailApp,
  }]
};